import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import * as  Http from '../../http'
import { ErrorCode, AccountTypeName, AccountType } from '../../const'
import * as Business from '../../utils/business'

export default class ListUser extends Component {
  state = {
    isShow: false,
    userInfo: null
  }
  password = ''
  role = ''
  phone = ''
  fullname = ''
  address = ''

  show = (userInfo) => {
    this.password = ''
    this.role = userInfo.RoleGroupId
    this.accountType = userInfo.AccountType
    this.phone = userInfo.Phone
    this.fullname = userInfo.Fullname
    this.address = userInfo.Address
    this.setState({
      isShow: true,
      userInfo
    })
  }

  close = () => {
    this.setState({
      isShow: false
    })
  }

  save = () => {
    if (this.role === null || this.role === undefined || this.role === 'NOT_DEFINED') {
      Business.showAlert({
        title: 'Error',
        content: 'Role is not defined'
      })
      return;
    }
    const newUserInfo = {
      Username: this.state.userInfo.Username,
      Password: this.password,
      RoleGroupId: this.role,
      AccountType: AccountType.Admin,
      Phone: this.phone,
      Fullname: this.fullname,
      Address: this.address
    }
    Http.updateUser(newUserInfo)
      .then(res => {
        if (res.Success) {
          Business.showAlert({
            title: 'Success',
            content: 'Update successful'
          })
          this.props.onUpdateUser && this.props.onUpdateUser()
          this.close()
        } else {
          switch (res.ErrorCode) {
            case ErrorCode.PermissionDenie:
              Business.showAlert({
                title: 'Error',
                content: 'You are not permission'
              })
              break;
            default:
              break;
          }
        }
      })
  }

  render() {
    if (!this.state.isShow) return <div />

    return (
      <Modal show={this.state.isShow} onHide={this.close}>
        <Modal.Header closeButton>
          <Modal.Title>Update User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form>
            <div className="form-group">
              <label for="exampleInputEmail1">Username</label>
              <input type="text" disabled className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" defaultValue={this.state.userInfo.Username} />
            </div>
            <div className="form-group">
              <label for="fullname">Fullname</label>
              <input type="text" className="form-control" id="fullname" placeholder="Fullname"
                defaultValue={this.fullname}
                onChange={event => {
                  this.fullname = event.target.value
                }}
              />
            </div>
            {/* <div className="form-group">
              <label for="exampleFormControlSelect1">Account Type</label>
              <select className="form-control" id="exampleFormControlSelect1"
                onChange={event => {
                  this.accountType = Business.getAccountTypeId(event.target.value)
                }}
                defaultValue={Business.getAccountTypeName(this.state.userInfo.AccountType)}
              >
                <option>{AccountTypeName['1']}</option>
                <option>{AccountTypeName['2']}</option>
              </select>
            </div> */}
            <div className="form-group">
              <label for="exampleFormControlSelect1">Role</label>
              <select className="form-control" id="exampleFormControlSelect1"
                onChange={event => {
                  this.role = Business.getRoleIdByName(event.target.value)
                }}
                defaultValue={Business.getRoleName(this.state.userInfo.RoleGroupId)}
              >
                {[...['NOT_DEFINED'], ...Business.getAllRoleName()].map(item =>
                  (<option>{item}</option>)
                )}
              </select>
            </div>
            <div className="form-group">
              <label for="phone">Phone</label>
              <input type="text" className="form-control" id="phone" placeholder="Phone"
                defaultValue={this.phone}
                onChange={event => {
                  this.phone = event.target.value
                }}
              />
            </div>
            <div className="form-group">
              <label for="address">Address</label>
              <input type="text" className="form-control" id="address" placeholder="Address"
                defaultValue={this.address}
                onChange={event => {
                  this.address = event.target.value
                }}
              />
            </div>
            {/* <div className="form-group">
              <label for="exampleInputPassword1">Password</label>
              <input type="password" className="form-control" id="exampleInputPassword1" placeholder="Password"
                defaultValue={this.password}
                onChange={event => {
                  this.password = event.target.value
                }}
              />
            </div> */}
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" style={{
            backgroundColor: '#FFE600',
            borderColor: '#7F7E82',
            borderRadius: '5px',
            marginRight: '2px',
            fontWeight: 600,
            marginLeft: "auto"
          }} onClick={this.save}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/User/UpdateUser.js